module.exports = __webpack_public_path__ + "static/media/Nizar Jegham.a2365809.png";